import { ConfigOption } from '@ngx-formly/core';
import { FormlyTaskListWidgetComponent } from './components/formly-task-list-widget/formly-task-list-widget.component';

export const TASK_FORMLY_TYPES: ConfigOption['types'] = [
    { name: 'formly-task-list-widget', component: FormlyTaskListWidgetComponent },
];
